import styled from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  header: React.ReactNode
  children: React.ReactNode
  onClick?: () => void
} & ClassNameProps

export const StatsBlock = (props: Props) => {
  return (
    <Root className={props.className} onClick={props.onClick}>
      <Header>{props.header}</Header>
      <Body>{props.children}</Body>
    </Root>
  )
}

const Root = styled.section`
  background: var(--background-1);
  border-radius: 12px;
  border: 1px solid var(--background-3);
  display: flex;
  flex-direction: column;
`
const Header = styled.header`
  padding: 18px;
  border-bottom: 1px solid var(--background-3);
  display: flex;
`
const Body = styled.main`
  padding: 18px;
  display: grid;
  flex: 1;
`

const HeaderContent = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: space-between;

  flex: 1;
`
const HeaderTitle = styled.div`
  color: var(--text-12);
  font-size: 14px;
  font-weight: 700;
`

StatsBlock.Header = HeaderContent
StatsBlock.Title = HeaderTitle
